const PROD = {
    HOST: "https://api.tangentmotorsport.com",
    BASE_URL: "https://apps.tangentmotorsport.com",
    ENV: "PROD",
    PUBLIC_KEY: "pk_live_9sDT0CIki5a0Vd5joIXEpxeP"
};

const TEST = {
    HOST: "https://api-test.tangentmotorsport.com",
    BASE_URL: "https://ui-test.tangentmotorsport.com",
    ENV: "TEST",
    PUBLIC_KEY: "pk_test_vgl93fcYRMfk6rqOWSWU1BWH"
};

const DEV = {
    HOST: "http://localhost:6050",
    BASE_URL: "http://localhost:6050",
    ENV: "DEV",
    PUBLIC_KEY: "pk_test_vgl93fcYRMfk6rqOWSWU1BWH"
};

module.exports =
    process.env.REACT_APP_ENV === "PROD"
        ? PROD
        : process.env.REACT_APP_ENV === "DEV"
            ? DEV
            : TEST;
